import { Tabs } from '@scale/scaleui';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SquadsManagement } from 'react-scale/components/ExpertManagement/CommunityManagement/SquadsManagement';
import { UserManagement } from 'react-scale/components/ExpertManagement/CommunityManagement/UserManagement';
import { useSetQueryParams } from 'react-scale/components/ExpertManagement/hooks/useSetQueryParams';
import useQueryParams from 'react-scale/corp/hooks/useQueryParams';

enum CommunityMode {
  Squads = 'squads',
  Users = 'users',
}

export const CommunityManagementContent: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { setQueryParams } = useSetQueryParams();
  const handleTabChange = (tabId: string) => {
    setQueryParams({ communityMode: tabId });
  };
  const params = useQueryParams();
  const communityMode = params.communityMode as CommunityMode;
  useEffect(() => {
    if (!communityMode) {
      setQueryParams({ communityMode: CommunityMode.Squads });
    }
  }, [communityMode, history, location.pathname, params, setQueryParams]);
  return (
    <>
      <Tabs
        className="my-2"
        onChange={handleTabChange}
        tabs={[
          {
            id: CommunityMode.Squads,
            label: 'Squads Management',
          },
          {
            id: CommunityMode.Users,
            label: 'User Management',
          },
        ]}
        value={communityMode ?? ''}
        variant="default"
      />
      {communityMode === CommunityMode.Squads && <SquadsManagement />}
      {communityMode === CommunityMode.Users && <UserManagement />}
    </>
  );
};
